goog.provide('el8.core.service.Notifier');

goog.require('el8.template.core.service.Notifier');
goog.require('el8.service.intervals');


/**
 * This file implements a per-page message area that we can use to notify the user
 * that work is in progress (e.g., "object is saving...") or to confirm that work
 * has been accomplished (e.g., "object has been deleted."). In app, thse are
 * yellow messages that show at the top of the page.
 *
 * Every application should instantiate a single Notifier to display messages. Because
 * there is only Notifier per application, any call to notify() will override any
 * currently displaying messages permanently.
 */

el8.core.service.Notifier = function(spec) {
    this._zIndex = 50000; // arbitrary large number: guarantee Notifier is always on top
    this._UILayoutFn = spec.UILayoutFn;
};

el8.core.service.Notifier.prototype._init = function() {
    if (this._isInit) { return; }
    this._isInit = true;

    this._container = $(el8.template.core.service.Notifier.container()).hide();
    $(document.body).append(this._container);

    this._msgContainer = $('#notify-message', this._container);

    var that = this;
    this._UILayoutFn().addResizeListener(function() { that._position(); });
};

el8.core.service.Notifier.prototype._position = function() {
    this._container.css('z-index', this._zIndex);
    var width = this._container.width();
    var appWidth = this._UILayoutFn().getAppWidth();
    this._container.css('left', (appWidth/2) - (width/2));
};

el8.core.service.Notifier.prototype.clear = function() {
    if (!this._isInit) { return; }
    this._msgContainer.empty();
    this._container.hide();
};

el8.core.service.Notifier.prototype.notify = function(msg, time) {

    if (!this._isInit) { this._init(); }

    // Default display for 10 seconds
    var timeoutTime = time || 10*1000;
    this.clear();
    // make sure a previous notifier's timeout doens't make us disappear
    if (this._currentTimeout) { $.el8_clearTimeout(this._currentTimeout); }

    this._msgContainer.html(msg);
    this._container.show();

    this._position();

    var that = this;
    this._currentTimeout = $.el8_setTimeout(function() {
        that.clear();
    }, timeoutTime);

};
